import { alpha } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";
import { getColors } from "../../../utils";

interface StyleProps {
  dark: boolean;
  secondaryColor: string;
}

export const getVerificationStyles = ({ dark, secondaryColor }: StyleProps) => {
  const AppColors = getColors();
  const colors = {
    background: AppColors.surfaceSecondary,

    card: dark ? "#111" : "#F8FAFC",

    text: dark ? "#fff" : "#111827",

    muted: dark ? "#94A3B8" : "#64748B",

    border: dark ? "#334155" : "#CBD5E1",
  };

  return {
    colors,

    container: {
      width: "100%",
      minHeight: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      boxSizing: "border-box",
      py: 2,
    } satisfies SxProps<Theme>,

    card: {
      width: "100%",

      maxWidth: {
        xs: "100%",
        sm: 500,
      },
      mt: 2,

      p: 2,

      borderRadius: 2,

      textAlign: "center",

      backgroundColor: colors.card,

      boxShadow: "none",
    } satisfies SxProps<Theme>,

    icon: {
      width: {
        xs: 58,
        sm: 80,
      },

      height: {
        xs: 58,
        sm: 80,
      },

      mx: "auto",

      mb: {
        xs: 2,
        sm: 3,
      },

      borderRadius: "50%",

      display: "flex",

      justifyContent: "center",

      alignItems: "center",

      backgroundColor: alpha(secondaryColor, 0.3),
    } satisfies SxProps<Theme>,

    subtitle: {
      color: colors.muted,

      my: 2,

      fontSize: {
        xs: 13,
        sm: 16,
      },
    } satisfies SxProps<Theme>,

    email: {
      display: "inline-flex",
      maxWidth: "100%",
      mt: 2,

      p: 2,

      mb: {
        xs: 3,
        sm: 4,
      },

      borderRadius: 50,

      overflow: "hidden",

      textOverflow: "ellipsis",

      whiteSpace: "nowrap",
      border: AppColors.border,
    } satisfies SxProps<Theme>,

    codeContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      gap: {
        xs: 0.5,
        sm: 1,
      },
      flexWrap: "nowrap",

      mb: 3,
    } satisfies SxProps<Theme>,

    input: {
      width: {
        xs: 40,
        sm: 42,
      },

      "& .MuiInputBase-root": {
        height: {
          xs: 40,
          sm: 40,
        },
      },

      "& .MuiOutlinedInput-input": {
        textAlign: "center",
        fontSize: {
          xs: 18,
          sm: 22,
        },
        fontWeight: 700,
        padding: 0,
        height: "100%",
        boxSizing: "border-box",
      },
    } satisfies SxProps<Theme>,

    timer: {
      display: "inline-flex",

      alignItems: "center",

      p: 2,

      mb: 3,

      borderRadius: 50,

      fontSize: {
        xs: 11,
        sm: 14,
      },

      border: `1px solid ${secondaryColor}`,

      color: secondaryColor,
    } satisfies SxProps<Theme>,

    button: {
      width: "100%",

      mb: {
        xs: 1,
        sm: 2,
      },

      fontWeight: 600,
    } satisfies SxProps<Theme>,

    buttonConfirm: {
      width: "100%",
    } satisfies SxProps<Theme>,

    error: {
      my: 3,
    } satisfies SxProps<Theme>,
  };
};
